import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_gbfbknczne: FaireBrandEntity = {
  token: "b_gbfbknczne",
  type: "brand",
  name: "Crystal Deal· Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/66cd6487e4ddd01d05cfe00d997c406482d0973363d34eef1d044c7e69060d1a.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/fc9283d2f45bf1c5b1533d35cd5fd5a5d2d9280da57082ea6c7ff1ea2ce14182.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/66cd6487e4ddd01d05cfe00d997c406482d0973363d34eef1d044c7e69060d1a.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/fc9283d2f45bf1c5b1533d35cd5fd5a5d2d9280da57082ea6c7ff1ea2ce14182.jpeg",
  location: "Ontario, CA, USA",
  minimumOrderDollars: 109,
  rating: 5,
  reviewCount: 58,
  isInsider: true,
  description:
    "Started in 2006, Women owned company. We grow up from 1 person, family to a team. Now we have team members in California, China Donghai/Xiamen, Madagascar, Brazil, Morocco.\n\nOur main target is providing good quality and special products with good cost to our wholesale customers, for you to have more margin and easier work. \n\nIf you have your own design to be fulfill, you may contact us as well, we will do our best to help you produce!",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:39.441Z",
    importedBy: "entity-db-cli",
  },
};
